import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Grid, Stack } from '@mui/material';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import get from 'lodash/get';

import { transformDataSize } from 'utils';
import Card from '../components/Card';

const Counters = () => {
  const isLoading = useSelector((state) => get(state.ecosystems.ecosystem.loading, 'count', false));
  const {
    network: { direction: usageData },
    countData: data,
  } = useSelector((state) => state.ecosystems.ecosystem);
  const total = (usageData?.[0]?.Total || 0) + (usageData?.[1]?.Total || 0);

  return (
    <Card icon={PieChartOutlineIcon} isLoading={isLoading} title="Total Count">
      <Grid container>
        <Grid item xs={4}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              px: 2,
            }}
          >
            <ArrowUpwardIcon sx={{ width: 32, height: 32, color: '#11AEFB' }} />
            <Typography textAlign="center" sx={{ fontSize: 14, mt: 2, mb: 1 }}>
              Total Transferred
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 20, fontWeight: 500 }}>
              {transformDataSize(total)}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={8} sx={{ borderLeft: '1px solid #EFF2F7' }}>
          <Grid container>
            <Grid item xs={6}>
              <Grid container direction="column" justifyContent="space-evenly" alignItems="stretch" spacing={1}>
                <Grid item xs={6} sx={{ borderBottom: '1px solid #EFF2F7' }}>
                  <Stack py="22px" alignItems="center" columnGap={0.25}>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 20, fontWeight: 500 }}
                      data-testid="util-count-applications"
                    >
                      {data?.applications}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 400, lineHeight: '20px' }}>Applications</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack py="22px" alignItems="center" columnGap={0.25}>
                    <Typography variant="body1" sx={{ fontSize: 20, fontWeight: 500 }} data-testid="util-count-things">
                      {data?.things}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 400, lineHeight: '20px' }}>Things</Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container direction="column" justifyContent="space-evenly" alignItems="stretch" spacing={1}>
                <Grid item xs={6} sx={{ borderBottom: '1px solid #EFF2F7', borderLeft: '1px solid #EFF2F7' }}>
                  <Stack py="22px" alignItems="center" columnGap={0.25}>
                    <Typography variant="body1" sx={{ fontSize: 20, fontWeight: 500 }} data-testid="util-count-users">
                      {data?.users}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 400, lineHeight: '20px' }}>Users</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={6} sx={{ borderLeft: '1px solid #EFF2F7' }}>
                  <Stack py="22px" alignItems="center" columnGap={0.25}>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 20, fontWeight: 500 }}
                      data-testid="util-count-gateways"
                    >
                      {data?.gateways}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 400, lineHeight: '20px' }}>Gateways</Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default Counters;
